import { Button, Modal } from 'antd';
import { useTranslate } from '@tolgee/react';
import { CommonRefund } from 'services/api/return';
import { getShopeeCredential, updateCredential } from 'services/api/admin';
import chatttSDK from 'services/chattt';
import posthog from '@leyan/lytics';
import { ButtonProps } from 'antd/es/button';
import Icon from '@ant-design/icons';
import { ReactComponent as SvgForward } from 'assets/icons/forward.svg';
import { isMac } from 'utils/is';

const Detail = (
  props: Omit<ButtonProps, 'onClick'> & CommonRefund & { onSuccess?: () => void },
) => {
  const { t } = useTranslate();
  const { children, externalStoreId, returnSn, externalTradeId, onSuccess, ...btnProps } = props;

  const gotoShopeeRefund = () => {
    if (chatttSDK && chatttSDK?.shopee?.toReturnDetail) {
      getShopeeCredential(parseInt(externalStoreId, 10))
        .then((credential) => {
          if (!credential.account || !credential.password) {
            throw new Error('account or password empty');
          }
          chatttSDK!.shopee
            .toReturnDetail({
              returnSn,
              account: {
                region: credential.region.toLowerCase(),
                isCnsc: credential.accountType === 1,
                account: credential.account,
                password: credential.password,
              },
              tip: `${t('trade.虾皮退款页弹框顶部条')}${
                isMac
                  ? '<button style="margin-left:16px; cursor:pointer; border:1px solid #ccc;width:40px;height:24px;" onclick="window.close()">✖</button>'
                  : ''
              }`,
              shopId: externalStoreId,
            })
            .then((rst) => {
              try {
                const { status, accChg, invalidInfo } = rst || {};

                if (status === 'done') {
                  posthog.capture('$returnRst', {
                    custRreport: {
                      opType: 'detail',
                      status: 'done',
                      reqData: props,
                      rst: JSON.stringify(rst),
                    },
                  });
                  onSuccess?.();

                  if (accChg?.type && accChg?.account && accChg?.pass) {
                    updateCredential({
                      externalId: externalStoreId,
                      account: accChg.account,
                      password: accChg.pass,
                      status: 1,
                    }).catch(() => {});
                  }
                } else if (status === 'close') {
                  posthog.capture('$returnRst', {
                    custRreport: {
                      opType: 'detail',
                      status: 'close',
                      reqData: props,
                      rst: JSON.stringify(rst),
                    },
                  });
                  updateCredential({
                    externalId: externalStoreId,
                    account: credential.account,
                    password: credential.password,
                    status: 0,
                  }).catch(() => {});
                  if (invalidInfo) {
                    const { shopId, account, newAccount, message } = invalidInfo;
                    const acc = !newAccount ? account : newAccount;
                    if (message === 'invalid_shop_account') {
                      Modal.error({
                        content: t('trade.帐号店铺无关联提示', { shopId, acc }),
                      });
                    } else if (message === 'invalid_returnSn') {
                      Modal.error({
                        content: 'invalid returnSn',
                      });
                    }
                  }
                }
              } catch (e) {
                // do nothing
              }
            })
            .catch((e) => {
              Modal.error({
                content: t('trade.退款页打开失败'),
              });
              posthog.capture('$returnRst', {
                custRreport: {
                  opType: 'detail',
                  status: 'openFail',
                  catchTIp: t('trade.退款页打开失败'),
                  reqData: props,
                },
              });
            });
        })
        .catch(() => {
          const content = t('trade.帐号不存在', { shopId: externalStoreId });
          Modal.error({
            title: t('trade.登录错误'),
            content,
          });
          posthog.capture('$returnRst', {
            custRreport: {
              opType: 'detail',
              status: 'noAccount',
              catchTIp: content,
              reqData: props,
            },
          });
        });
    } else {
      Modal.error({
        title: t('trade.版本过低'),
        content: t('trade.退款客户端升级'),
      });
    }
  };
  return (
    <Button type="default" size="small" onClick={gotoShopeeRefund} {...btnProps}>
      {children || t('trade.卖家中心退款详情')} <Icon component={SvgForward} />
    </Button>
  );
};

export default Detail;
